module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Legion-S2.6e1e975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Legion-S2.jpg
// module id = HE/3
// module chunks = 0